import React, { useState } from "react";

function Navbar() {

  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav>

    <div className="logo">
  <a href="#home" className="logo-link">
    <img src="./Images/RCML_LOGO.png" alt="RCML Logo" className="logo-img" />
    RESIDENCY CLUB MIDC LATUR
  </a>
</div>

      <div className="logo1"><img src="./Images/RCML_LOGO.png" alt="RCML Logo" className="logo-img" />RCML</div>

      <ul className={`nav-links ${isOpen ? "active" : ""}`}>
        <li><a href="#home">Home</a></li>
        <li><a href="#Pricing">Services</a></li>
        <li><a href="#gallery">Gallery</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>

      <a href="#contact" className="btn quote-btn">Get Quote</a>

      {/* Hamburger */}
      <div 
        className="menu-icon"
        onClick={() => setIsOpen(!isOpen)}
      >
        ☰
      </div>
    </nav>
  );
}

export default Navbar;